import { useEffect } from 'react'

export const useDelayedCallback = (callback: () => void, delayMs: number) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      callback()
    }, delayMs)

    return () => clearTimeout(timer)
  }, [callback, delayMs])
}
